module.exports = __webpack_public_path__ + "img/sym-report-01.7eae4176.svg";